export const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://notoputrooffice.com/api"
    : "https://notoputrooffice.com/api";
